import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ValidatorFn,
  AbstractControl,
  FormControl,
} from "@angular/forms";
import { MatDialog } from "@angular/material";

import {
  Errors,
  FooterService,
  LocalService,
  ManagerService,
} from "../../../core";
import { PopupMessageService } from "../../message/services/message.service";
import { CONSTANTS } from "../../../config/constants";
import { SellerRewardsDialogComponent } from "../seller-rewards-dialog/seller-rewards-dialog.component";
// import korean from '../../../../assets/i18n/Korean.json';
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import countries from "../../../../assets/countries.json";
import { PreferenceStateService } from "src/app/core/services/preference-state.service";
declare var window: any;
// declare var drift: any;
export interface User {
  name: string;
  code: string;
}
export function forbiddenNamesValidator(Services: any[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const index = Services.findIndex((Service) => {
      return new RegExp("^" + Service.name + "$").test(control.value);
    });
    return index < 0 ? { forbiddenNames: { value: control.value } } : null;
  };
}
@Component({
  selector: "app-support-page",
  templateUrl: "./support-page.component.html",
  styleUrls: ["./support-page.component.scss"],
})
export class SupportPageComponent implements OnInit, AfterViewInit, OnDestroy {
  errors: Errors = { errors: {} };
  supportForm: FormGroup;
  userData;
  isSalesChallenge: Boolean = false;
  isSalesChallengeUser: Boolean = false;
  isActivityChallenge: Boolean = false;
  isActivityChallengeUser: Boolean = false;
  isChallengePreference: Boolean = false;
  nonExistingUser: Boolean = true;
  validations = CONSTANTS.validationMessages.supportForm;
  id;
  allCategory;
  tabData;
  addClass: string;
  removeClass: string;
  lang: string;
  switchRole;
  isAdmin: Boolean = false;
  options: User[] = countries;
  regionsList = ["USA", "CANADA", "LATAM", "EMEAR", "APJ"];
  myControl = new FormControl(null, [
    Validators.required,
    forbiddenNamesValidator(this.options),
  ]);
  filteredOptions: Observable<User[]>;
  incentiveProgram: string;
  constructor(
    private footerService: FooterService,
    private managerService: ManagerService,
    private popupMessageService: PopupMessageService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private preferenceService: PreferenceStateService
  ) {}

  ngOnInit() {
    this.lang = localStorage.getItem("selectedLanguage");
    this.incentiveProgram = LocalService.get("incentiveProgram");
    this.switchRole = localStorage.getItem("selectedRole");
    // this.tabData = 'sellerFaq';
    this.tabData = "inquiryForm";
    this.userData = LocalService.get("userProfile");
    this.getSupportCategory();
    this.supportForm = this.formBuilder.group({
      subject: ["", [Validators.required, Validators.maxLength(250)]],
      description: ["", [Validators.required]],
      requestorEmail: ["", [Validators.email]],
      ticketCategory: ["", [Validators.required]],
      region: ["", [Validators.required]],
    });
    if (typeof window === "undefined") {
      return;
    }
    if (this.userData) {
      this.findPendingRoles();
      this.getCompanyPreferences();
      this.getUserPreferences(6);
      this.getUserPreferences(7);
    }
    // this.initializeDrift();
    // drift.SNIPPET_VERSION = '0.3.1';
    // drift.load('y3tiysgug5yp');
    // window.drift.show();
    this.getStates();
    this.getValidations();
    this.preferenceService.selectedOption.subscribe((selected) => {
      console.log("Selected option changed:", selected);
      // Perform actions based on selected option
      this.incentiveProgram = selected;
      console.log("changed incentive", this.incentiveProgram);
    });
  }
  disableBtn = false;
  // Validation
  getValidations() {
    var lang = localStorage.getItem("selectedLanguage");
    if (lang == "English") {
      this.validations = CONSTANTS.validationMessages.supportForm;
    } else if (lang == "Korean") {
      this.validations = CONSTANTS.validationMessages.korean_supportForm;
    } else if (lang == "Japanese") {
      this.validations = CONSTANTS.validationMessages.japanese_supportForm;
    }
  }

  getStates() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith<string | User>(""),
      map((value) => {
        if (value != null) {
          return typeof value === "string" ? value : value.name;
        }
      }),
      map((name) => (name ? this._filter(name) : this.options.slice()))
    );
  }
  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();
    return this.options.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }
  findPendingRoles() {
    const admin = "COMPANY_ADMIN";
    if (this.userData.roles) {
      this.isAdmin = this.userData.roles.find((item) => item.name === admin);
    }
  }
  getCompanyPreferences() {
    if (this.userData.company && this.userData.company.id) {
      const companyParams = {
        companyId: this.userData.company.id,
      };
      this.managerService.getCompanyPreferences(companyParams).subscribe(
        (data) => {
          const preferences = data.companyPreferences.map(
            (item) => item.enabled
          );
          this.isSalesChallenge = preferences[0];
          this.isActivityChallenge = preferences[1];
          const preference = data.companyPreferences.find(
            (item) => item.name === "COMPANY_SALES_CHALLENGES_AND_REWARDS"
          );
          if (preference) {
            this.isChallengePreference = preference.enabled;
          }
          // this.showDistributePoints = preferences[5];
        },
        (err) => {
          this.errors = err;
        }
      );
    }
  }
  getUserPreferences(id) {
    let params;
    if (this.userData.id) {
      params = {
        userId: this.userData.id,
        preferenceId: id,
      };
      this.managerService.getUserPreferences(params).subscribe(
        (data) => {
          if (id === 6) {
            this.isSalesChallengeUser = data.enabled;
          }
          if (id === 7) {
            this.isActivityChallengeUser = data.enabled;
          }
        },
        (err) => {
          this.errors = err;
        }
      );
    }
  }

  sellerNoRecorFound(searchValue) {
    searchValue = "";
    const queryParam = {
      searchText: searchValue,
      companyId: this.userData.company.id,
    };
    this.managerService.getpoSearchResult(queryParam).subscribe(
      (data) => {
        if (data) {
          const poSearchResult = data;
          //  this.storeService.addHeaderClass.next(true);
          document.getElementById("is_index").classList.add("is-index");
          const dialogRef = this.dialog.open(SellerRewardsDialogComponent, {
            width: "700px",
            data: {
              name: "sellerNoRecordFoundText",
              message: poSearchResult,
              popClaimPOSearch: "Notext",
            },
            // data: 'sellerNoRecordFoundText',
          });
          dialogRef.afterClosed().subscribe((result) => {
            document.getElementById("is_index").classList.remove("is-index");
          });
        }
      },
      (err) => {
        this.errors = err;
      }
    );
  }
  ngOnDestroy() {
    if (typeof window === "undefined") {
      return;
    }
    // window.driftt.hide();
  }

  closeForm() {
    // this.tabData = null;
    this.supportForm.reset();
    this.myControl.reset();
  }

  initializeDrift() {
    let t: any = (window.driftt = window.drift = window.driftt || []);
    let date: any = new Date();
    if (!t.init) {
      if (t.invoked)
        return void (
          window.console &&
          console.error &&
          console.error("Drift snippet included twice.")
        );
      (t.invoked = !0),
        (t.methods = [
          "identify",
          "config",
          "track",
          "reset",
          "debug",
          "show",
          "ping",
          "page",
          "hide",
          "off",
          "on",
        ]),
        (t.factory = function (e) {
          return function () {
            let n: any = Array.prototype.slice.call(arguments);
            return n.unshift(e), t.push(n), t;
          };
        }),
        t.methods.forEach(function (e) {
          t[e] = t.factory(e);
        }),
        (t.load = function (t) {
          let e: any = 3e5,
            n: any = Math.ceil(date / e) * e,
            o: any = document.createElement("script");
          (o.type = "text/javascript"),
            (o.async = !0),
            (o.crossorigin = "anonymous"),
            (o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js");
          let i: any = document.getElementsByTagName("script")[0];
          i.parentNode.insertBefore(o, i);
        });
    }
  }

  raiseSupportRequest(button: any) {
    var lang = localStorage.getItem("selectedLanguage");
    button.disabled = true;
    const supportParams = {
      subject: this.supportForm.value.subject,
      description: this.supportForm.value.description,
      categoryId: this.supportForm.value.ticketCategory,
      country: this.myControl.value,
      region: this.supportForm.value.region,
    };
    if (!this.userData.primaryEmail) {
      supportParams["requestorEmail"] = this.supportForm.value.requestorEmail;
    } else {
      supportParams["requestorUsername"] = this.userData.username;
      supportParams["requestorEmail"] = this.userData.primaryEmail;
    }
    this.footerService.postSupportRequest(supportParams).subscribe(
      (data) => {
        let msg = "Support request sent successfully.";
        if (lang == "Korean") {
          msg = "지원 요청이 성공적으로 전송되었습니다";
        }
        if (lang == "Japanese") {
          msg = "サポートリクエストが正常に送信されました";
        }
        this.popupMessageService.showSuccess(msg, "success", "supportCaseForm");
        this.supportForm.reset();
        this.myControl.reset();
      },
      (err) => {
        button.disabled = false;
        this.errors = err;
      }
    );
  }

  getSupportCategory() {
    const region =
      this.userData.company == null
        ? ""
        : "region=" + this.userData.company.region;

    const selectedRole =
      localStorage.getItem("selectedRole") == "manager" ? "LEADER" : "SELLER";

    let param = "";
    if (region) {
      param = region;
    }
    if (selectedRole) {
      param = param + "&console=" + selectedRole;
    }

    this.footerService.getSupportCategory(param).subscribe(
      (data) => {
        this.allCategory = data;
        var lang = localStorage.getItem("selectedLanguage");
        if (lang == "Korean" || lang == "Japanese") {
          this.allCategory[0]["categoryName"] =
            lang == "Korean" ? "기술적 인 문제" : "技術的な問題";
          this.allCategory[1]["categoryName"] =
            lang == "Korean" ? "영업 과제-제안" : "セールスチャレンジ-オファー";
          this.allCategory[2]["categoryName"] =
            lang == "Korean" ? "영업 과제-클레임" : "セールスチャレンジ-請求";
          this.allCategory[3]["categoryName"] =
            lang == "Korean"
              ? "활동 도전-제안"
              : "アクティビティチャレンジ-オファー";
          this.allCategory[4]["categoryName"] =
            lang == "Korean"
              ? "활동 도전-클레임"
              : "アクティビティチャレンジ-請求";
          this.allCategory[5]["categoryName"] =
            lang == "Korean"
              ? "활동 도전-창조"
              : "アクティビティチャレンジ-作成";
          this.allCategory[6]["categoryName"] =
            lang == "Korean" ? "보상 점수" : "報酬ポイント";
          this.allCategory[7]["categoryName"] =
            lang == "Korean" ? "보상 항공권" : "特典チケット";
          this.allCategory[8]["categoryName"] =
            lang == "Korean" ? "리더 보드" : "リーダーボード";
          this.allCategory[9]["categoryName"] =
            lang == "Korean" ? "대시 보드 지표" : "ダッシュボードメトリック";
          this.allCategory[10]["categoryName"] =
            lang == "Korean" ? "대시 보드 알림" : "ダッシュボードアラート";
          this.allCategory[11]["categoryName"] =
            lang == "Korean" ? "세금 정보 /보고" : "税務情報/報告";
          this.allCategory[12]["categoryName"] =
            lang == "Korean" ? "보상 콘테스트" : "報酬コンテスト";
          this.allCategory[13]["categoryName"] =
            lang == "Korean" ? "다른" : "その他";
        }
      },
      (err) => {
        this.errors = err;
      }
    );
  }

  openDescription() {
    document.getElementById("is_index").classList.add("is-index");
    const dialogRef = this.dialog.open(SellerRewardsDialogComponent, {
      data: "supportDescription",
    });

    dialogRef.afterClosed().subscribe((result) => {
      document.getElementById("is_index").classList.remove("is-index");
    });
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  // openTabs(value) {
  //   this.tabData = value;
  //   if (this.tabData === 'sneak') {
  //     window.open('http://salesconnect.cloudapps.cisco.com/SCContentLauncher?cid=36b168a3-7394-49aa-bfb3-34ec49a05662&&view=https%3A%2F%2Fsalesconnect.cloudapps.cisco.com%2Frmod%3Fcontenttraceid%3D36b168a3-7394-49aa-bfb3-34ec49a05662%26contenturl%3D%2Fdownload%2Frmod%2Fsecure%2F0119%2Fseller-rewards.mp4', '_blank');
  //   }
  //   if (this.tabData === 'rewardsGlance') {
  //     window.open('https://www.cisco.com/c/dam/en/us/products/se/2019/1/Collateral/seller-rewards-aag.pdf', '_blank');
  //   }
  //   if (this.tabData === 'leaderOverview') {
  //     window.open('http://salesconnect.cloudapps.cisco.com/SCContentLauncher?cid=e1663cc8-a45c-4331-a64b-ebc1cdc769ff&&view=https%3A%2F%2Fsalesconnect.cloudapps.cisco.com%2Frmod%3Fcontenttraceid%3De1663cc8-a45c-4331-a64b-ebc1cdc769ff%26contenturl%3D%2Fdownload%2Frmod%2Fsecure%2F0219%2Fpersona-leader-cta.mp4', '_blank');
  //   }
  //   if (this.tabData === 'leaderFaq') {
  //     window.open('https://www.cisco.com/c/dam/en/us/products/se/2019/1/Collateral/seller-rewards-leader-faq.pdf', '_blank');
  //   }
  //   if (this.tabData === 'sellerOverview') {
  //     window.open('http://salesconnect.cloudapps.cisco.com/SCContentLauncher?cid=71835dc1-9f6e-4953-b82b-0d7280c912af&&view=https%3A%2F%2Fsalesconnect.cloudapps.cisco.com%2Frmod%3Fcontenttraceid%3D71835dc1-9f6e-4953-b82b-0d7280c912af%26contenturl%3D%2Fdownload%2Frmod%2Fsecure%2F0219%2Fpersona-seller-cta.mp4', '_blank');
  //   }
  //   if (this.tabData === 'sellerFaq') {
  //     window.open('https://www.cisco.com/c/dam/en/us/products/se/2019/1/Collateral/seller-rewards-faq.pdf', '_blank');
  //   }
  //   if (this.tabData === 'howToTutorials') {
  //     window.open('http://salesconnect.cloudapps.cisco.com/SCContentLauncher?cid=b6ca2955-e81e-4e97-b84b-822f6b77c70b&&view=https%3A%2F%2Fsalesconnect.cloudapps.cisco.com%2Frmod%3Fcontenttraceid%3Db6ca2955-e81e-4e97-b84b-822f6b77c70b%26contenturl%3D%2Fdownload%2Frmod%2Fsecure%2F0319%2Fleader-how-create-profile.mp4', '_blank');
  //   }
  //   if (this.tabData === 'programTerms') {
  //     window.open('https://www.cisco.com/c/dam/en/us/products/se/2019/1/Collateral/seller-rewards.pdf', '_blank');
  //   }
  //   if (this.tabData === 'enrollmentGuide') {
  //     window.open('https://www.cisco.com/c/dam/en/us/products/se/2019/1/Collateral/seller-rewards-enroll-guide.pdf', '_blank');
  //   }

  //   if (this.tabData !== 'inquiryForm') {
  //    this.supportForm.reset();
  //   }
  // }
  openTabs(value) {
    this.tabData = value;
    /*For Multilingual*/
    var lang = localStorage.getItem("selectedLanguage");
    // if(lang == 'Korean') {
    //  this.validations = CONSTANTS.validationMessages.korean_supportForm;
    // }
    // if(lang == 'Japanese') {
    //   this.validations = CONSTANTS.validationMessages.japanese_supportForm;
    // }
    /*For Multilingual*/
    this.addClass = "sm-view";
    window.scroll(0, 410);
    if (this.tabData !== "inquiryForm") {
      this.supportForm.reset();
      this.myControl.reset();
    }
  }
  /*remove the class */
  removeTab(event, value) {
    this.addClass = "";
    this.tabData = "";
  }
}
